import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestHistory } from '../../interfaces/my-profile/request-history';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RequestHistoryService {

  constructor(private http: HttpClient) { }

  getAllHistory(userId: string): Observable<RequestHistory[]> {
    return this.http.get<RequestHistory[]>(`MyProfile/RequirementsByUser?userId=${userId}`)
      .pipe(map((arr) => arr.filter((row) => new Date(row.requirementDate) > new Date(2021, 9, 26))));
  }

  deleteRequest(requirementId: number) {
    return this.http.post<RequestHistory[]>(`/Requirement/Delete/${requirementId}`, {});
  }

}
